// 教員のエンティティ
export class Teacher {
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // フルネーム DB型(*varchar256)
  public full_name?: string;
  // フルネームカナ DB型(*varchar256)
  public full_name_kana?: string;
  // 性別 DB型(*varchar20)
  public gender?: string;
  // ろう・難聴とのかかわり DB型(*varchar256)
  public relationship_deaf?: string;
  // 生年月日 DB型(DATE)
  public birth_day?: Date;
  // 郵便番号 DB型(varchar(50))
  public zip_code?: string;
  // 都道府県 DB型(varchar(50))
  public prefecture?: string;
  // 市区町村名 DB型(*varchar256)
  public city_name?: string;
  // 以降の住所 DB型(*varchar256)
  public address_line1?: string;
  // マンション名 DB型(*varchar256)
  public address_line2?: string;
  // メールアドレス DB型(*varchar256)
  public email?: string;
  // Gmailアドレス DB型(*varchar256)
  public gmail?: string;
  // LINE_ID DB型(*varchar256)
  public line_id?: string;
  // 銀行コード DB型(*varchar256)
  public bank_code?: string;
  // 銀行名 DB型(*varchar256)
  public bank_name?: string;
  // 銀行支店番号 DB型(*varchar256)
  public bank_branch_code?: string;
  // 銀行支店名 DB型(*varchar256)
  public bank_branch?: string;
  // 銀行預金種別 DB型(*varchar20)
  public bank_type?: string;
  // 銀行口座番号 DB型(*varchar20)
  public bank_account_number?: string;
  // 銀行口座名義（カタカナ） DB型(*varchar64)
  public bank_account_name_kana?: string;
  // 申込日時 DB型(TIMESTAMP)
  public application_dt?: Date;
  // 顔写真パス DB型(*varchar256)
  public img_path?: string;
  // ニックネーム DB型(*varchar256)
  public nickname?: string;
  // 現役/既卒 DB型(*varchar20)
  public is_active_or_graduate?: string;
  // 学校名 DB型(*varchar64)
  public school_name?: string;
  // 最終学歴 DB型(*varchar64)
  public final_education?: string;
  // 勤務先 DB型(*varchar256)
  public work_place?: string;
  // 資格 DB型(*varchar256)
  public qualification?: string;
  // 資格（その他） DB型(*varchar256)
  public qualification_other?: string;
  // デフ児に対する指導経験の有無 DB型(*varchar1024)
  public teaching_experience?: string;
  // 対応できる学年 DB型(*varchar256)
  public target_school_year?: string;
  // 教えられる教科 DB型(*varchar64)
  public subject?: string;
  // 重複障碍児への対応 DB型(*varchar20)
  public duplicate_disable?: string;
  // 指導に関する希望 DB型(*varchar512)
  public hope?: string;
  // 週の希望勤務回数 DB型(*varchar64)
  public weekly_work?: string;
  // どこで知ったか？ DB型(*varchar256)
  public where_found?: string;
  // 紹介者の名前 DB型(*varchar256)
  public introducer?: string;
  // 応募動機 DB型(*varchar256)
  public motivation?: string;
  // 自己紹介 DB型(*varchar1024)
  public self_introduction?: string;
  // 強み生かしてどんなことができるか DB型(*varchar1024)
  public advantage?: string;
  // アピール文 DB型(*varchar1024)
  public appeal?: string;
  // アピール動画URL DB型(*varchar256)
  public appeal_movie_url?: string;
  // 退会時期がわかっている場合 DB型(*varchar64)
  public time_to_quit?: string;
  // 授業一言コメントデフォルト値 DB型(*varchar1024)
  public default_lesson_comment?: string;
  // 採用 DB型(*flg)
  public is_recruit?: boolean;
  // アイコン DB型(*varchar256)
  public icon?: string;
  // 基本稼働曜日 DB型(*varchar256)
  public work_day_of_week?: string;
  // 授業料 DB型(DOUBLE)
  public lesson_price?: any;
  // 報酬 DB型(DOUBLE)
  public fee_amount?: any;
  // オンライン会議用ツールのURL DB型(*varchar256)
  public zoom_url?: string;
  // ZoomミーティングID DB型(*varchar20)
  public zoom_id?: string;
  // Zoomパスワード DB型(*varchar64)
  public zoom_password?: string;
  // Zoomを利用？ DB型(*flg)
  public is_use_zoom?: boolean;
  // 面接情報URL DB型(*varchar256)
  public interview_url?: string;
  // 授業動画保存場所 DB型(*varchar256)
  public lesson_movie_save_url?: string;
  // 表示可 DB型(*flg)
  public is_show?: boolean;
  // 表示順 DB型(@INT)
  public top_order?: number;
  // 予約ページで表示する(CO専用） DB型(*flg)
  public is_show_reservation_page?: boolean;
  // 現在担当可能 DB型(*flg)
  public now_available?: boolean;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Teacher {
    const entity = new Teacher();
    entity.user_id = record['user_id'];
    entity.full_name = record['full_name'];
    entity.full_name_kana = record['full_name_kana'];
    entity.gender = record['gender'];
    entity.relationship_deaf = record['relationship_deaf'];
    entity.birth_day = record['birth_day'];
    entity.zip_code = record['zip_code'];
    entity.prefecture = record['prefecture'];
    entity.city_name = record['city_name'];
    entity.address_line1 = record['address_line1'];
    entity.address_line2 = record['address_line2'];
    entity.email = record['email'];
    entity.gmail = record['gmail'];
    entity.line_id = record['line_id'];
    entity.bank_code = record['bank_code'];
    entity.bank_name = record['bank_name'];
    entity.bank_branch_code = record['bank_branch_code'];
    entity.bank_branch = record['bank_branch'];
    entity.bank_type = record['bank_type'];
    entity.bank_account_number = record['bank_account_number'];
    entity.bank_account_name_kana = record['bank_account_name_kana'];
    entity.application_dt = record['application_dt'];
    entity.img_path = record['img_path'];
    entity.nickname = record['nickname'];
    entity.is_active_or_graduate = record['is_active_or_graduate'];
    entity.school_name = record['school_name'];
    entity.final_education = record['final_education'];
    entity.work_place = record['work_place'];
    entity.qualification = record['qualification'];
    entity.qualification_other = record['qualification_other'];
    entity.teaching_experience = record['teaching_experience'];
    entity.target_school_year = record['target_school_year'];
    entity.subject = record['subject'];
    entity.duplicate_disable = record['duplicate_disable'];
    entity.hope = record['hope'];
    entity.weekly_work = record['weekly_work'];
    entity.where_found = record['where_found'];
    entity.introducer = record['introducer'];
    entity.motivation = record['motivation'];
    entity.self_introduction = record['self_introduction'];
    entity.advantage = record['advantage'];
    entity.appeal = record['appeal'];
    entity.appeal_movie_url = record['appeal_movie_url'];
    entity.time_to_quit = record['time_to_quit'];
    entity.default_lesson_comment = record['default_lesson_comment'];
    entity.is_recruit = record['is_recruit'];
    entity.icon = record['icon'];
    entity.work_day_of_week = record['work_day_of_week'];
    entity.lesson_price = record['lesson_price'];
    entity.fee_amount = record['fee_amount'];
    entity.zoom_url = record['zoom_url'];
    entity.zoom_id = record['zoom_id'];
    entity.zoom_password = record['zoom_password'];
    entity.is_use_zoom = record['is_use_zoom'];
    entity.interview_url = record['interview_url'];
    entity.lesson_movie_save_url = record['lesson_movie_save_url'];
    entity.is_show = record['is_show'];
    entity.top_order = record['top_order'];
    entity.is_show_reservation_page = record['is_show_reservation_page'];
    entity.now_available = record['now_available'];
    return entity;
  }
  static getTypeFitEntity(value: any): Teacher {
    const entity = new Teacher();
    entity.user_id = value.user_id;
    entity.full_name = value.full_name;
    entity.full_name_kana = value.full_name_kana;
    entity.gender = value.gender;
    entity.relationship_deaf = value.relationship_deaf;
    entity.birth_day = value.birth_day;
    entity.zip_code = value.zip_code;
    entity.prefecture = value.prefecture;
    entity.city_name = value.city_name;
    entity.address_line1 = value.address_line1;
    entity.address_line2 = value.address_line2;
    entity.email = value.email;
    entity.gmail = value.gmail;
    entity.line_id = value.line_id;
    entity.bank_code = value.bank_code;
    entity.bank_name = value.bank_name;
    entity.bank_branch_code = value.bank_branch_code;
    entity.bank_branch = value.bank_branch;
    entity.bank_type = value.bank_type;
    entity.bank_account_number = value.bank_account_number;
    entity.bank_account_name_kana = value.bank_account_name_kana;
    entity.application_dt = value.application_dt;
    entity.img_path = value.img_path;
    entity.nickname = value.nickname;
    entity.is_active_or_graduate = value.is_active_or_graduate;
    entity.school_name = value.school_name;
    entity.final_education = value.final_education;
    entity.work_place = value.work_place;
    entity.qualification = value.qualification;
    entity.qualification_other = value.qualification_other;
    entity.teaching_experience = value.teaching_experience;
    entity.target_school_year = value.target_school_year;
    entity.subject = value.subject;
    entity.duplicate_disable = value.duplicate_disable;
    entity.hope = value.hope;
    entity.weekly_work = value.weekly_work;
    entity.where_found = value.where_found;
    entity.introducer = value.introducer;
    entity.motivation = value.motivation;
    entity.self_introduction = value.self_introduction;
    entity.advantage = value.advantage;
    entity.appeal = value.appeal;
    entity.appeal_movie_url = value.appeal_movie_url;
    entity.time_to_quit = value.time_to_quit;
    entity.default_lesson_comment = value.default_lesson_comment;
    entity.is_recruit = value.is_recruit;
    entity.icon = value.icon;
    entity.work_day_of_week = value.work_day_of_week;
    entity.lesson_price = value.lesson_price;
    entity.fee_amount = value.fee_amount;
    entity.zoom_url = value.zoom_url;
    entity.zoom_id = value.zoom_id;
    entity.zoom_password = value.zoom_password;
    entity.is_use_zoom = value.is_use_zoom;
    entity.interview_url = value.interview_url;
    entity.lesson_movie_save_url = value.lesson_movie_save_url;
    entity.is_show = value.is_show;
    entity.top_order = value.top_order;
    entity.is_show_reservation_page = value.is_show_reservation_page;
    entity.now_available = value.now_available;
    return entity;
  }
}
